import { Plus, SquareArrowOutUpRight } from 'lucide-solid';
import { mergeProps } from 'solid-js';
import Link from '~/components/Link';
import { Button } from '~/components/ui/Button';
import { externalLinks } from '~/consts';
import { Localized } from '~/i18n';
import { getTranslationKey } from './utils';

type MultiAppHeaderProps = {
  btnOnClick: () => void;
};

export default function MultiAppHeader(props: MultiAppHeaderProps) {
  const merged = mergeProps({}, props);
  return (
    <div class="flex justify-between">
      <div>
        <h1 class={`text-2xl`}>
          <Localized translationKey="pages.multi_applications.page_header" />
        </h1>
        <p class="flex items-center gap-1 text-fg-muted text-sm mt-1">
          <Localized translationKey="pages.multi_applications.sub_header" />
          <Link
            href={externalLinks.multiApplicationsLinks.overview}
            target="_blank"
            data-testid="multi-app-learn-more-link"
            rel="noopener noreferrer"
            class="flex items-center gap-1 text-sm text-link-primary"
          >
            <Localized translationKey={getTranslationKey('learn_more')} />
            <SquareArrowOutUpRight
              width={14}
              height={14}
            />
          </Link>
        </p>
      </div>
      <Button
        onClick={merged.btnOnClick}
        size="sm"
        data-testid="create-application-modal"
      >
        <span class="flex items-center gap-2">
          <Plus />
          <Localized translationKey="pages.multi_applications.create_application" />
        </span>
      </Button>
    </div>
  );
}
